import { render, staticRenderFns } from "./CorrectSum.vue?vue&type=template&id=f86ec99e"
import script from "./CorrectSum.vue?vue&type=script&lang=js"
export * from "./CorrectSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports